



















































































































































import Vue from 'vue'
import LoginWrapper from '@/components/LoginWrapper'
import ClipLoader from '@/components/vue-spinner/ClipLoader.vue'
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators'
import { Select, Option, Checkbox } from 'element-ui'
import fb from '../../firebase'
import './InviteForm.scss'
import { TranscodingRegion } from '@/types/admin'
import helpers from '@/helpers'
import { CollectionNames } from '@/types'
import { sortBy } from 'lodash'

interface RegionOption {
  name: string,
  value: string
}

export default Vue.extend({
  name: 'InviteForm',
  computed: {
    userLoggedIn (): boolean {
      return this.$store.direct.state.user.userLoggedIn
    },
    currentUserEmail (): string {
      return this.$store.direct.state.user.email
    },
    activeTeam (): string {
      return this.$store.direct.state.team.activeTeam
    },
    userRole (): string {
      const profile = this.$store.direct.state.user.profile
      if (profile) {
        return profile.role
      }
      return ''
    },
    transcodingregions (): { [id: string]: TranscodingRegion } {
      return this.$store.direct.state.admin.transcodingregions
    },
    possibleRegions (): RegionOption[] {
      const regions: RegionOption[] = []
      for (const key in this.transcodingregions) {
        regions.push({ name: this.transcodingregions[key].name, value: key })
      }
      return sortBy(regions, 'name')
    },
    tosUrl (): string {
      return this.$store.direct.state.admin.legalinfo.tosUrl
    },
    privacyUrl (): string {
      return this.$store.direct.state.admin.legalinfo.privacyUrl
    },
    tosVersion (): number {
      return this.$store.direct.state.admin.legalinfo.tosLastPublished.seconds
    },
    privacyVersion (): number {
      return this.$store.direct.state.admin.legalinfo.privacyLastPublished.seconds
    }
  },
  data: () => ({
    user: {
      email: '',
      first_name: '',
      last_name: '',
      password: '',
      confirmPassword: '',
      role: '',
      team_id: '',
      transcodingregion: '',
      invite_id: ''
    },
    setupfailed: false,
    setupErrorMessage: '',
    showForm: false,
    invite_id: '',
    loginError: '',
    formSent: false,
    legalAgreement: false,
    initializing: true,
    showAddedToTeam: false,
    invitedTeam: ''
  }),
  async created () {
    if (this.$route.params.id === '') {
      this.$router.push({ name: 'login' })
      return
    }

    this.loadInviteData(this.$route.params.id)
  },
  methods: {
    getCurrentURL (): string {
      return window.location.href
    },
    getURL (name, params = {}): string {
      return helpers.getURL(this.$router, name, params)
    },
    async loadInviteData (inviteId) {
      // if the user is already logged in they already part of the team and don't need the form
      // send them in but add them to the team etc. and give them a message
      try {
        const snap = await fb.db.collection(CollectionNames.INVITES).doc(inviteId).get()
        const invite = snap.exists ? snap.data() : undefined

        if (!invite) {
          this.$message({ type: 'error', message: 'The supplied invite is not valid' })
          this.$router.push({ name: 'login' })
          return
        }

        if (invite.signup_complete === true) {
          if (this.userLoggedIn) {
            this.$router.push({ name: 'events' })
            this.$message('This invite has been completed previously.')
          } else {
            this.$router.push({ name: 'login' })
            this.$message('This invite has been completed previously. Please login to continue.')
          }
          return
        }

        const hasProfileFunc = fb.functions.httpsCallable('addTeamIfInvitedUserExists')
        const response = await hasProfileFunc(snap.id)
        if (response.data.success === false) {
          this.$message({ type: 'error', message: 'The supplied invite is not valid' })
          this.$router.push({ name: 'login' })
          console.error('Failed to check for invite-associated profile:', response.data.reason ?? 'unknown')
          return
        }

        this.initializing = false

        const hasExistingProfile = response.data.has_profile ?? false
        const teamName = response.data.team_name ?? 'unkown'

        if (this.userLoggedIn && this.currentUserEmail !== '' && this.currentUserEmail === invite.email) {
          if (hasExistingProfile === true) {
            this.showJoinedTeamMessage(teamName)
          } else {
            this.$router.push({ name: 'events' })
            console.error('Logged in while not having an invite-associated profile')
            this.$message({ type: 'error', message: 'Logged in while not having an invite-associated profile' })
          }
        } else if (this.userLoggedIn && this.currentUserEmail !== '' && this.currentUserEmail !== invite.email) {
          this.$router.push({ name: 'events' })
          this.$message({ type: 'error', message: 'The invite you are trying to use is not yours' })
        } else if (hasExistingProfile) {
          this.showJoinedTeamMessage(teamName)
        } else {
          this.invite_id = snap.id
          this.user.invite_id = snap.id
          this.user.email = invite.email
          this.user.role = invite.role
          this.user.team_id = invite.team_id
          this.showForm = true
        }
      } catch (error) {
        console.error(`error inviteform ${inviteId} ${error}`)
      }
    },
    formSubmitted () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.formSent = false
      } else {
        const createFunc = fb.functions.httpsCallable('createInviteUser')
        this.formSent = true
        this.$v.$reset()
        createFunc({...this.user, tosVersion: this.tosVersion, privacyVersion: this.privacyVersion}).then((result) => {
          if (result.data.success === true) {
            fb.firebase.auth().signInWithEmailAndPassword(this.user.email, this.user.password).then(res => {
              if (res.user === null) throw new Error('Could find user in resolution')
              this.loginError = ''
              this.$store.direct.dispatch.user.signInUser(res.user)
              this.$router.push({ name: 'events' })
            }).catch((error) => {
              console.log(error)
              this.$router.push({ name: 'login' })
            })
          } else {
            this.setupfailed = true
            this.setupErrorMessage = result.data.reason ?? 'unknown'
          }
        }).catch((error) => {
          console.error(error)
          this.setupfailed = true
          this.setupErrorMessage = 'registration error'
        })
      }
    },
    showJoinedTeamMessage (teamName: string): void {
      this.showAddedToTeam = true
      this.invitedTeam = teamName
    },
    teamAddedAcknowledged (): void {
      if (this.userLoggedIn) this.$router.push({ name: 'events' })
      else this.$router.push({ name: 'login' })
    }
  },
  validations: {
    user: {
      email: {
        email,
        minLength: minLength(4)
      },
      first_name: {
        required,
        minLength: minLength(2)
      },
      last_name: {
        required,
        minLength: minLength(2)
      },
      password: {
        required,
        minLength: minLength(6)
      },
      confirmPassword: {
        sameAsPassword: sameAs('password')
      },
      transcodingregion: {
        required
      }
    },
    legalAgreement: {
      checked: val => val === true
    }
  },
  components: {
    LoginWrapper,
    'clip-loader': ClipLoader,
    'el-select': Select,
    'el-option': Option,
    'el-checkbox': Checkbox
  }
})
